import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import analytics from "../images/analytics.png";
import datacollect from "../images/datacollection.png";
import leaderboard from "../images/leaderboard.png";
import scouting from "../images/scouting.png";
import { useGlobal } from "../context/GlobalProvider";

export default function Home({ user, signOut }) {
  const navigate = useNavigate();
  const { setCurrentTab } = useGlobal();
  useEffect(() => {
    setCurrentTab("home");
  }, []);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Grid container sx={{ width: "100%", mt: 3 }} spacing={3}>
        <Grid item xs={12}>
          <Stack
            direction="column"
            spacing={3}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Typography
              sx={{ fontSize: 30, alignSelf: "center", textAlign: "center" }}
            >
              <b>
                Welcome to Torch 5804 Robotics Collection App – Ignite Insights!
              </b>
            </Typography>
            <Typography sx={{ fontSize: 16, textAlign: "center" }}>
              Welcome to the Torch 5804 Robotics Collection App – a tool built
              by our team, for every team! We designed this app to make
              real-time data collection and analytics easier for all robotics
              competitions. Whether you're scouting on the field, analyzing
              match trends, or strategizing for alliance selections, this app is
              here to help everyone gain a competitive edge.
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack direction={"column"} spacing={2}>
            <Box
              sx={{
                display: "inline-block",
                backgroundImage: `url(${datacollect})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px", // Optional: Rounded corners
                overflow: "hidden", // Ensure button stays inside box
                borderWidth: 2,
                borderColor: "#ffe8c0",
                borderStyle: "solid",
              }}
            >
              <Button
                fullWidth
                sx={{
                  height: { xs: 150, md: 200, lg: 250 },
                  color: "white",
                  fontWeight: "bold",
                  fontSize: { xs: "1.5rem", md: "2rem", lg: "3rem" },
                  backgroundColor: "rgba(50, 50, 50, 0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.4)",
                  },
                }}
                onClick={() => navigate("/datacollector/reefscape")}
              >
                Data Collection
              </Button>
            </Box>
            <Typography
              sx={{
                fontSize: 16,
                alignSelf: "center",
                my: 1,
                textAlign: "center",
              }}
            >
              Our app allows teams to gather live match data seamlessly. With an
              easy-to-use interface, you can quickly log robot performance,
              autonomous routines, cycle times, and endgame actions—all while
              keeping up with fast-paced events.
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack direction={"column"} spacing={2}>
            <Box
              sx={{
                display: "inline-block",
                backgroundImage: `url(${analytics})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px", // Optional: Rounded corners
                overflow: "hidden", // Ensure button stays inside box
                borderWidth: 2,
                borderColor: "#ffe8c0",
                borderStyle: "solid",
              }}
            >
              <Button
                fullWidth
                sx={{
                  height: { xs: 150, md: 200, lg: 250 },
                  color: "white",
                  fontWeight: "bold",
                  fontSize: { xs: "1.5rem", md: "2rem", lg: "3rem" },
                  backgroundColor: "rgba(50, 50, 50, 0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.4)",
                  },
                }}
                onClick={() => navigate("/analysis")}
              >
                Analytics
              </Button>
            </Box>
            <Typography sx={{ fontSize: 16, textAlign: "center" }}>
              Gone are the days of flipping through paper notes! With instant
              data visualization, our app helps you spot trends, compare
              performance, and make smarter strategy decisions. Need to know the
              best scorer? Who’s the fastest climber? It’s all in the data,
              ready when you are.
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack direction={"column"} spacing={2}>
            <Box
              sx={{
                display: "inline-block",
                backgroundImage: `url(${scouting})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px", // Optional: Rounded corners
                overflow: "hidden", // Ensure button stays inside box
                borderWidth: 2,
                borderColor: "#ffe8c0",
                borderStyle: "solid",
              }}
            >
              <Button
                fullWidth
                sx={{
                  height: { xs: 150, md: 200, lg: 250 },
                  color: "white",
                  fontWeight: "bold",
                  fontSize: { xs: "1.5rem", md: "2rem", lg: "3rem" },
                  backgroundColor: "rgba(50, 50, 50, 0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.4)",
                  },
                }}
                onClick={() => navigate("/scouting")}
              >
                Scouting
              </Button>
            </Box>

            <Typography sx={{ fontSize: 16, textAlign: "center" }}>
              Get detailed insights on every team before they even hit the
              field. Our app allows you to document robot specs, mechanisms, and
              capabilities so you can build a complete picture of potential
              alliance partners—or opponents!
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack direction={"column"} spacing={2}>
            <Box
              sx={{
                display: "inline-block",
                backgroundImage: `url(${leaderboard})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "8px", // Optional: Rounded corners
                overflow: "hidden", // Ensure button stays inside box
                borderWidth: 2,
                borderColor: "#ffe8c0",
                borderStyle: "solid",
              }}
            >
              <Button
                fullWidth
                sx={{
                  height: { xs: 150, md: 200, lg: 250 },
                  color: "white",
                  fontWeight: "bold",
                  fontSize: { xs: "1.5rem", md: "2rem", lg: "3rem" },
                  fontWeight: "bold",
                  backgroundColor: "rgba(50, 50, 50, 0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.4)",
                  },
                }}
                onClick={() => navigate("/leaderboard")}
              >
                Leaderboards
              </Button>
            </Box>
            <Typography sx={{ fontSize: 16, textAlign: "center" }}>
              Track your performance in real-time! The app ranks teams based on
              match data, helping participants spot top robots, key players, and
              hidden gems before alliance selections. Whether you're scouting or
              competing, use the leaderboard to stay ahead!
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
